// extracted by mini-css-extract-plugin
module.exports = {"horizontalSizing":"horizontalSizing_nTgXQ","container":"container_r3tGG","elevatedContainerSizing":"elevatedContainerSizing_ufdxq","elevatedContainer":"elevatedContainer_vdMma"};